import config from 'config'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { commonActions } from 'srcReact/components'

const DowngradeConfirmationPopin = (props) => {
  const { t, subscriptionPlan, updatePlan } = props

  const handleClosePopin = () => {
    const { closePopin } = props

    closePopin()
  }

  const isLoading = () => {
    if (subscriptionPlan && subscriptionPlan.loading) {
      return true
    }
    return false
  }

  return (
    <Fragment>
      <div className='popin-content--image'>
        <img src={`${config.assetUrl}/images/void.svg`} alt='process' />
      </div>
      <h2 className='popin-content--title popin-content--title-down'>
        {t('billing.popin.downgradeConfirmation.title')}
      </h2>
      <p className='popin-content--text'>{t('billing.popin.downgradeConfirmation.text')}</p>
      <div className='popin-content--controllers'>
        <button
          type='button'
          className='button is-secondary popin-content--secondary-button'
          onClick={() => handleClosePopin()}>
          {t('billing.popin.downgradeConfirmation.btnSecondary')}
        </button>
        <button type='button' className='button is-danger' onClick={() => !isLoading() && updatePlan()}>
          {isLoading() ? t('billing.popin.downgradeConfirmation.loading') : t('billing.popin.downgradeConfirmation.btnDanger')}
        </button>
      </div>
    </Fragment>
  )
}

function mapStateToProps(state) {
  const { subscriptionPlan } = state.subscription

  return { subscriptionPlan }
}

const actionCreators = {
  closePopin: commonActions.closePopin,
}

const ExtendedComponent = withTranslation('common')(DowngradeConfirmationPopin)
const connectedDowngradeConfirmationPopin = connect(mapStateToProps, actionCreators)(ExtendedComponent)

export { connectedDowngradeConfirmationPopin as DowngradeConfirmationPopin }
